export default {
  header: {
    create: 'Vytvoriť API kľúč',
    update: 'Aktualizovať API kľúč',
  },
  warning: {
    title: 'API kľúč je zobrazený iba raz',
    subtitle: 'API kľúč nie je možné znova získať. Skopírujte ho a uložte na bezpečné miesto',
  },
};
